<div class="document-requirement">
  <div class="req-header">
    <span *ngIf="documentRequirement.requirement && documentRequirement.requirement.length > 0; else requirementNeededIcon">
      <mat-icon class="req-met-icon success">check_circle</mat-icon>
    </span>
    <ng-template #requirementNeededIcon>
      <mat-icon color="warn" class="req-met-icon">cancel</mat-icon>
    </ng-template>
    <div class="tw-uppercase tw-align-middle tw-self-center tw-text-xs">
      {{ documentRequirement.name || documentRequirement.shortName }} <span *ngIf="documentRequirement.requiredForOffer || documentRequirement.requiredForContract">
        - {{ documentRequirement.documentQuantity }}
        <span *ngIf="(documentRequirement.alias ==='business_tax_returns' || documentRequirement.alias === 'personal_tax_returns') && documentRequirement.documentQuantity > 1">years</span>
        <span *ngIf="(documentRequirement.alias ==='business_tax_returns' || documentRequirement.alias === 'personal_tax_returns') && documentRequirement.documentQuantity === 1">year</span>
        <span *ngIf="documentRequirement.alias === 'bank_statement' && documentRequirement.documentQuantity > 1">months </span>
        <span *ngIf="documentRequirement.alias === 'bank_statement' && documentRequirement.documentQuantity === 1">month </span>
        (required)
      </span>
    </div>
  </div>

  <div
    class="requirement-pill {{ uploadingDocument ? 'uploading-document' : ''}}"
    attr.data-cy="unmet-requirement-{{documentRequirement.category.value}}"
    *ngIf="!readOnly && !documentRequirement.requirement || !readOnly && documentRequirement.requirement.length < 1 && dealStage !== 'funded' && dealStage !== 'inactive'; else requirementMet"
    [matMenuTriggerFor]="menu">
      <div class="requirement-info" *ngIf="!uploadingDocument">
        Add {{ documentRequirement.name || documentRequirement.shortName }}
      </div>
      <div class="requirement-info-disabled" *ngIf="uploadingDocument">
        Document(s) Uploading...
      </div>
  </div>

  <mat-menu
    #menu="matMenu"
    class="doc-upload-menu">
    <p class="upload-types-header">Add attachment from</p>
    <button
      mat-menu-item
      class="upload-type-btn"
      (click)="fileInput.click()"
      [disabled]="uploadingDocument"
      data-cy="computer-upload">
      Computer
    </button>
    <button
      class="upload-type-btn"
      mat-menu-item
      [matMenuTriggerFor]="documentsTab"
      [disabled]="filteredDocuments.length === 0 || uploadingDocument"
      data-cy="documents-tab-upload">
      Documents Tab
    </button>
  </mat-menu>

  <mat-menu #documentsTab="matMenu" class="documents-tab-options">
    <div class="docs-tab-options">
      <button
        *ngFor="let document of filteredDocuments"
        mat-menu-item
        (click)="$event.stopPropagation()">
        <mat-checkbox
          class="doc-checkbox"
          (change)="toggleSelected(document, $event.checked)"
          [checked]="docSelected(document)">
          {{ document.title }}
        </mat-checkbox>
      </button>
    </div>
    <div mat-menu-item>
      <button
        class="attach-docs"
        mat-flat-button
        color="primary"
        (click)="attachSelected()"
        [disabled]="!selectedDocuments.length">
        Attach Selected <span *ngIf="selectedDocuments.length">({{ selectedDocuments.length }})</span>
      </button>
    </div>
  </mat-menu>

  <input
    #fileInput
    type="file"
    (change)="uploadDocuments($event.target.files)"
    style="display:none;"
    multiple
    attr.data-cy="computer-upload-input-{{documentRequirement.category.value}}"
    [accept]="typesAccepted"
  />

  <ng-template #requirementMet>
    <div
      class="met-requirement-pill mat-elevation-z1"
      *ngFor="let requirement of documentRequirement.requirement"
      attr.data-cy="met-requirement-{{documentRequirement.category.value}}">
      <div class="requirement-info">
        <div class="doc-title" (click)="openDocument(requirement)">
          <mat-icon
            *ngIf="requirement.mimetype === 'application/pdf'"
            class="doc-icon">
            picture_as_pdf
          </mat-icon>
          <mat-icon
            *ngIf="requirement.mimetype === 'image/png' || requirement.mimetype === 'image/jpeg'"
            class="doc-icon">
            insert_photo
          </mat-icon>
          <mat-icon
            *ngIf="requirement.mimetype !== 'image/png' && requirement.mimetype !== 'image/jpeg' && requirement.mimetype !== 'application/pdf'"
            class="doc-icon">
            insert_drive_file
          </mat-icon>
          {{ requirement.title }}
        </div>
        <div class="doc-size">
          <span class="bytes">({{ requirement.size | bytes }})</span>
          <mat-icon
            *ngIf="dealStage !== 'funded' && dealStage !== 'inactive'"
            class="deal-doc-detach"
            (click)="detach(requirement)"
            attr.data-cy="detach-requirement-{{documentRequirement.category.value}}">
            delete_outline
          </mat-icon>
        </div>
      </div>
    </div>
    <div
      class="requirement-pill {{ uploadingDocument ? 'uploading-document' : ''}}"
      attr.data-cy="met-requirement-{{documentRequirement.category.value}}-additional"
      *ngIf="!readOnly && !['application_signed','loanDisclosure'].includes(documentRequirement.alias) && !['funded','inactive'].includes(dealStage)"
      [matMenuTriggerFor]="menu">
      <div class="requirement-info" *ngIf="!uploadingDocument">
        Add {{ documentRequirement.name || documentRequirement.shortName }}
      </div>
      <div class="requirement-info-disabled" *ngIf="uploadingDocument">
        Document(s) Uploading...
      </div>
    </div>
  </ng-template>
</div>
